/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-06-15 11:44:49
 * @LastEditors: K
 * @LastEditTime: 2022-08-05 17:25:37
 */
import { Col, Row } from "antd";
import React, { ReactElement, useContext } from "react";
import { ThemeContext } from "../../theme/ThemeContext";

interface LabelProps {
  label?: string;
  style?: React.CSSProperties;
  text ?:string;
  ml?: string;
}

export const Label = ({ label, style, text, ml }: LabelProps): ReactElement => {
  const theme = useContext(ThemeContext);
  return (
    <Row
      style={{ ...style, height: style?.height ? style.height : "2.5rem" }}
      align="middle"
    >
      <Col
        style={{
          width: ml ? 4 : 2,    //用来判断数据监测页面的 label
          height: ml ? 20 : 10,
          backgroundColor: theme.c1,
        }}
      />
      <Col
        style={{
          fontSize: style?.fontSize ? style.fontSize : "1.25rem",
          color: theme.tc1,
          fontWeight: "bold",
          marginLeft: ml ? ml : 10,
        }}
      >
      {label}
      </Col>
      <Col>{text}</Col>
    </Row>
  );
};
